import Vue from "vue";
import VueI18n from "vue-i18n";
import co from "./lang/co";
import global from "./lang/global";
import id from "./lang/id";
import kh from "./lang/kh";
import mx from "./lang/mx";
import my from "./lang/my";
import pe from "./lang/pe";
import ph from "./lang/ph";
import pk from "./lang/pk";
import th from "./lang/th";
import vn from "./lang/vn";

Vue.use(VueI18n);

const messages = {
  co,
  global,
  id,
  kh,
  mx,
  my,
  pe,
  ph,
  pk,
  th,
  vn,
};

const i18n = new VueI18n({
  locale: "global",
  fallbackLocale: "global",
  messages,
});

export default i18n;
